<template>
  <div class="d-flex mt-2">

    <div v-if="previewOnlyWithLink" class="d-flex">
      <a v-if="file.url" :href="openLinkFileInModal ? null : file.url" @click="openLinkFileInModal ? askOpenImageLinkInModal(file.url) : null" target="_blank" class="preview-pdf" >
        {{ file.fileName }}
      </a>
      <button v-if="file.url" type="button" class="action-btn delete cursor-pointer ml-2 delete-action-btn-pdf" @click="deleteFile($event)">
        <i class="ph-custom ph-trash-bold"/>
      </button>
    </div>

    <div v-else-if="imagePreviewSrc || showImgFromUrl" class="item-preview-one-file">
      <div class="img-preview-one-file-container">
        <img :src="imagePreviewSrc ? imagePreviewSrc : file.url" alt="Image" class="img-preview-one-file cursor-pointer" @click="openModal(imagePreviewSrc ? imagePreviewSrc : getFileUrl(file.url))"/>
        <div v-if="showDelete" class="delete-btn-container">
          <button type="button" class="action-btn delete cursor-pointer" @click="deleteFile($event)">
            <i class="ph-custom ph-trash-bold"/>
          </button>
        </div>
      </div>
    </div>

    <div v-else-if="pdfPreviewSrc || showPdfFromUrl" class="d-flex">
      <a v-if="pdfPreviewSrc" @click="openLoadedPdfInNewWindow(pdfPreviewSrc)" target="_blank" class="preview-pdf">
        {{ file.fileName }}
      </a>
      <a v-else-if="showPdfFromUrl" :href="file.url" target="_blank" class="preview-pdf" >
        {{ file.fileName }}
      </a>
      <button type="button" class="action-btn delete cursor-pointer ml-2 delete-action-btn-pdf" @click="deleteFile($event)">
        <i class="ph-custom ph-trash-bold"/>
      </button>
    </div>

    <b-modal
      v-model="showModal"
      hide-footer
      centered
      size="lg"
      hide-backdrop
      content-class="p-0">
      <template #modal-header>
        <button type="button" class="close" @click="showModal = false" aria-label="Close">
          <i class="ph-custom ph-x-bold secondary-text-color"/>
        </button>
      </template>
      <img :src="selectedImageUrl" alt="Image agrandie" class="w-100">
    </b-modal>

  </div>
</template>

<script>
export default {
  name: 'PreviewOneFile',

  emits : ['openImageLinkInModal', 'deleteFileInPreview'],

  props: {
    fileId: {
      type: String,
      required: true,
    },
    imagePreviewSrc: {
      default: null
    },
    pdfPreviewSrc: {
      default: null
    },
    file: {
      type: Object,
      default: {}
    },
    previewOnlyWithLink: {
      type: Boolean,
      default: false
    },
    previewImageLinkInModal: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showModal: false,
      selectedImageUrl: null
    }
  },

  computed: {
    openLinkFileInModal() {
      return this.previewImageLinkInModal && this.file.id && !this.file.isPdf
    },
    showImgFromUrl() {
      return !this.imagePreviewSrc && !this.pdfPreviewSrc && this.file.id && !this.file.isPdf
    },
    showPdfFromUrl() {
      return !this.imagePreviewSrc && !this.pdfPreviewSrc && this.file.id && this.file.isPdf
    },
  },

  methods: {
    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

    openModal(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.showModal = true;
    },

    openLoadedPdfInNewWindow(pdfBase64) {
      let pdfWindow = window.open("")
      pdfWindow.document.write(
        "<body style='margin-left:-2px; margin-top:-2px; margin-right:2px; margin-bottom:2px; overflow: hidden;'><iframe width='100%' height='100%' src='"+pdfBase64+"'></iframe></body>"
      )
    },

    askOpenImageLinkInModal(url) {
      this.$emit('openImageLinkInModal', url)
    },

    deleteFile(event){
      //il faut vérifier pointerType car une enter key sur une autre entrée du formulaire peut faire office de 'click sur le prochain btn' avec un pointerType = "" au lieu de "mouse" ou "touch" par ex
      //et si le prochain btn est celui de suppression d'un preview file comme ici -> on prend pas en compte cet event !
      if(event && event.pointerType !== "") {
        this.$emit('deleteFileInPreview', this.fileId)
      }
    },
  },
}
</script>

<style scoped>

.item-preview-one-file {
  position: relative;
  -ms-flex: 0 0 48%;
  -webkit-box-flex: 0;
  flex: 0 0 48%;
  max-width: 48%;
  max-height: 150px;
  border-radius: 10px;
  overflow: hidden;
}

.img-preview-one-file-container {
  min-height: 45px;
  max-height: 100%;
  display: flex;
  justify-content: center;
}

.img-preview-one-file {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  align-self: center;
}

.preview-pdf {
  text-decoration: underline;
  cursor: pointer;
  align-self: center;
  word-break: break-all;
}
.preview-pdf:hover {
  color: var(--main-yellow-medium) !important;
}

.delete-btn-container {
  position: absolute;
  top: 10px;
  right: 0;
  margin-right: 0.5em;
}

.action-btn.delete {
  background-color: var(--main-red-medium);
  color: var(--main-black-dark);
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
}

.delete-action-btn-pdf.action-btn.delete {
  width: 25px;
  height: 25px;
  border-radius: 8px;
}
.delete-action-btn-pdf .ph-custom {
  font-size: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/PreviewOneFile.vue